(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('ChooseHeaderDialogController', ChooseHeaderDialogController);

	ChooseHeaderDialogController.$inject = ['$mdDialog', 'WineTable', 'column', 'lodash', '$log', 'UserService'];

	function ChooseHeaderDialogController($mdDialog, WineTable, column, lodash, $log, UserService){

		/* jshint validthis: true */
		var self = this;

		// the column number the user is operating on
		self.column = column;

		self.headers = [];

		self.choose = choose;
		self.close = close;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			self.headers = lodash.sortBy(WineTable.getHeaders(), 'name');

		}

		function choose(header){
			WineTable.setActiveHeader(self.column, header);

			// need to sync the columns with the user's local settings
			var columnSettings = lodash.pluck(WineTable.activeHeaders, 'id');

			$log.debug('Updating user settings to', columnSettings);

			$log.debug('New active headers', WineTable.activeHeaders);

			UserService.$localStorage.headers = columnSettings;

			self.close();
		}

		function close(){
			$mdDialog.hide();
		}
	}

})();
